import { Grid } from "@material-ui/core";
import React, { useEffect } from 'react'
import { Container, Typography, Box, Card, ToggleButton, ToggleButtonGroup } from "@mui/material";
import { keyframes } from '@mui/system';
import HistoryTable from "../Tabels/HistoryTable";
import ActiveLoans from "../Tabels/ActiveLoans";
import { UrlConstant } from "../../../commom/UrlConstant";
import Axios from "../../../config/axios";
import Repayment from "../Tabels/Repayment";
import { useLocation } from 'react-router-dom';
import { usePriceFormatter } from "../../../hooks";

// Keyframes animation for tab switching
const slideIn = keyframes`
  0% {
    opacity: 0;
    transform: scale(0.95);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
`;

function BoosterLoan() {
  const location = useLocation();
  const category = location.state?.category;
  const [selectedCategory, setSelectedCategory] = React.useState<String>(category || "Repayments");
  const [isBoosterLoan, setIsBoosterLoan] = React.useState<any>(false);
  const [isUpdatePaymentMethod, setIsUpdatePaymentMethod] = React.useState<any>(false);
  const [loading, setLoading] = React.useState<any>(false);
  const [boosterLoanSummary, setBoosterLoanSummary] = React.useState<any>();
  const [boosterLoanRepaymentData, setBoosterLoanRepaymentData] = React.useState<any>();
  const [boosterLoanActiveData, setBoosterLoanActiveData] = React.useState<any>();
  const [boosterLoanHistoryData, setBoosterLoanHistoryData] = React.useState<any>();
  const formatter = usePriceFormatter()

  const handleSelectedCategory = (
    event: React.MouseEvent<HTMLElement>,
    newCategory: string | null
  ) => {
    // Prevent unselecting the same tab - if clicking on already selected tab, do nothing
    if (newCategory === null || newCategory === selectedCategory) {
      return;
    }
    setSelectedCategory(newCategory);
  };

  const checkIsBoosterLoan = async () => {
    setLoading(true)
    try {
      const response = await Axios.get(
        UrlConstant.TradingAccount.CheckAccountStatus
      );
      const resData = response.data;
      if (resData.status === true) {
        setIsBoosterLoan(resData.data.boosterLoanOptIn);
      }
    } catch (error: any) {
      console.error("ERRR : ", error);
    } finally {
      setLoading(false)
    }
  };

  const getBoosterLoanSummary = async () => {
    setLoading(true)
    try {
      const response = await Axios.get(
        UrlConstant.BoosterLoan.GetBoosterSummary
      );
      const resData = response.data;
      if (resData.status === true) {
        setBoosterLoanSummary(resData.data);
      }
    } catch (error: any) {
      console.error("ERRR : ", error);
    } finally {
      setLoading(false)
    }
  };

  const getBoosterLoanRepayment = async () => {
    setLoading(true)
    try {
      const response = await Axios.get(
        UrlConstant.BoosterLoan.GetBoosterLoanRepayment
      );
      const resData = response.data;
      if (resData.status === true) {
        setBoosterLoanRepaymentData(resData.data);
      }
    } catch (error: any) {
      console.error("ERRR : ", error);
    } finally {
      setLoading(false)
    }
  };

  const getBoosterLoanActive = async () => {
    setLoading(true)
    try {
      const response = await Axios.get(
        UrlConstant.BoosterLoan.GetBoosterLoanActive.replace("{0}", "true")
      );
      const resData = response.data;
      if (resData.status === true) {
        setBoosterLoanActiveData(resData.data);
      }
    } catch (error: any) {
      console.error("ERRR : ", error);
    } finally {
      setLoading(false)
    }
  };

  const getBoosterHistory = async () => {
    setLoading(true)
    try {
      const response = await Axios.get(
        UrlConstant.BoosterLoan.GetBoosterLoanActive.replace("{0}", "false")
      );
      const resData = response.data;
      if (resData.status === true) {
        setBoosterLoanHistoryData(resData.data);
      }
    } catch (error: any) {
      console.error("ERRR : ", error);
    } finally {
      setLoading(false)
    }
  };



  useEffect(() => {
    checkIsBoosterLoan()
  }, [])
  useEffect(() => {
    if (isBoosterLoan) {
      getBoosterLoanSummary()
    }
  }, [isBoosterLoan])

  useEffect(() => {
    if (isBoosterLoan) {
      if (selectedCategory === "Repayments") {
        getBoosterLoanRepayment()
      } else if (selectedCategory === "Activeloans") {
        getBoosterLoanActive()
      } else {
        getBoosterHistory()
      }
    }
    setIsUpdatePaymentMethod(false)
  }, [isBoosterLoan, selectedCategory, isUpdatePaymentMethod])

  if (!isBoosterLoan && !loading) {
    return (
      <Container
        maxWidth={false}
        className="bg-color"
        sx={{
          minHeight: 'calc(100vh - 71px - 143px)',
          height: 'fit-content',
          padding: '30px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <Box sx={{ textAlign: 'center' }}>
          <Typography
            variant="h5"
            sx={{
              color: 'rgba(255, 255, 255, 0.7)',
              fontWeight: 500,
              fontSize: { xs: '18px', sm: '24px' }
            }}
          >
            Not Having Booster Loan
          </Typography>
        </Box>
      </Container>
    )
  }

  return <>
    <Container maxWidth={false} className="bg-color" style={{ minHeight: 'calc(100vh - 71px - 143px)', height: 'fit-content', padding: '30px' }}>
      {/* {loading && (
        <Box
          position="fixed"
          top={0}
          left={0}
          width="100vw"
          height="100vh"
          bgcolor="rgba(0, 0, 0, 0.5)" // Semi-transparent black background
          display="flex"
          justifyContent="center"
          alignItems="center"
          style={{
            backdropFilter: "blur(5px)", // Blur effect
            zIndex: 9999, // Ensures the loader stays above all elements
          }}
        >
          <CircularProgress color="primary" />
        </Box>
      )} */}
      <Typography
        variant="h4"
        sx={{
          fontSize: { xs: '22px', sm: '28px' },
          fontWeight: 700,
          color: '#fff',
          mb: 3,
          letterSpacing: '0.5px'
        }}
      >
        Booster Loan Details
      </Typography>

      <Box
        display="flex"
        flexDirection={{ xs: 'column', md: 'row' }}
        gap={{ xs: 2, md: 2.5 }}
        mb={4}
      >
        {/* Total Owning Card */}
        <Box flexGrow={1} sx={{ minWidth: { xs: '100%', md: 0 } }}>
          <Card
            sx={{
              background: 'linear-gradient(135deg, rgba(255, 42, 42, 0.12) 0%, rgba(255, 42, 42, 0.06) 100%)',
              border: '1px solid rgba(255, 42, 42, 0.2)',
              borderRadius: '16px',
              padding: '20px',
              height: '100%',
              transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
              boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)',
              '&:hover': {
                transform: 'translateY(-4px)',
                boxShadow: '0 8px 30px rgba(255, 42, 42, 0.25)',
                borderColor: 'rgba(255, 42, 42, 0.4)',
              }
            }}
          >
            <Typography
              sx={{
                fontSize: '14px',
                color: 'rgba(255, 255, 255, 0.7)',
                fontWeight: 500,
                mb: 1,
                textTransform: 'uppercase',
                letterSpacing: '1px'
              }}
            >
              Total Owning
            </Typography>
            <Typography
              sx={{
                fontSize: { xs: '24px', sm: '32px' },
                fontWeight: 700,
                color: '#FF2A2A',
                textShadow: '0 2px 8px rgba(255, 42, 42, 0.3)'
              }}
            >
              {formatter.balance(boosterLoanSummary?.totalAmount).display}
            </Typography>
          </Card>
        </Box>

        {/* Due this Week Card */}
        <Box flexGrow={1} sx={{ minWidth: { xs: '100%', md: 0 } }}>
          <Card
            sx={{
              background: 'linear-gradient(135deg, rgba(74, 122, 242, 0.12) 0%, rgba(74, 122, 242, 0.06) 100%)',
              border: '1px solid rgba(74, 122, 242, 0.2)',
              borderRadius: '16px',
              padding: '20px',
              height: '100%',
              transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
              boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)',
              '&:hover': {
                transform: 'translateY(-4px)',
                boxShadow: '0 8px 30px rgba(74, 122, 242, 0.25)',
                borderColor: 'rgba(74, 122, 242, 0.4)',
              }
            }}
          >
            <Typography
              sx={{
                fontSize: '14px',
                color: 'rgba(255, 255, 255, 0.7)',
                fontWeight: 500,
                mb: 1,
                textTransform: 'uppercase',
                letterSpacing: '1px'
              }}
            >
              Due this Week
            </Typography>
            <Typography
              sx={{
                fontSize: { xs: '24px', sm: '32px' },
                fontWeight: 700,
                color: '#4A7AF2',
                textShadow: '0 2px 8px rgba(74, 122, 242, 0.3)'
              }}
            >
              {formatter.balance(boosterLoanSummary?.dueInWeek).display}
            </Typography>
          </Card>
        </Box>

        {/* Due next Week Card */}
        <Box flexGrow={1} sx={{ minWidth: { xs: '100%', md: 0 } }}>
          <Card
            sx={{
              background: 'linear-gradient(135deg, rgba(78, 223, 109, 0.12) 0%, rgba(78, 223, 109, 0.06) 100%)',
              border: '1px solid rgba(78, 223, 109, 0.2)',
              borderRadius: '16px',
              padding: '20px',
              height: '100%',
              transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
              boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)',
              '&:hover': {
                transform: 'translateY(-4px)',
                boxShadow: '0 8px 30px rgba(78, 223, 109, 0.25)',
                borderColor: 'rgba(78, 223, 109, 0.4)',
              }
            }}
          >
            <Typography
              sx={{
                fontSize: '14px',
                color: 'rgba(255, 255, 255, 0.7)',
                fontWeight: 500,
                mb: 1,
                textTransform: 'uppercase',
                letterSpacing: '1px'
              }}
            >
              Due next Week
            </Typography>
            <Typography
              sx={{
                fontSize: { xs: '24px', sm: '32px' },
                fontWeight: 700,
                color: '#4EDF6D',
                textShadow: '0 2px 8px rgba(78, 223, 109, 0.3)'
              }}
            >
              {formatter.balance(boosterLoanSummary?.dueInNextWeek).display}
            </Typography>
          </Card>
        </Box>
      </Box>
      <Box sx={{ mb: 4 }}>
        <ToggleButtonGroup
          value={selectedCategory}
          exclusive
          onChange={handleSelectedCategory}
          sx={{
            width: '100%',
            display: 'flex',
            gap: 0.5,
            bgcolor: 'rgba(255, 255, 255, 0.08)',
            borderRadius: '16px',
            padding: '4px',
            boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)',
            border: '1px solid rgba(255, 255, 255, 0.1)',
            position: 'relative',
            '& .MuiToggleButton-root': {
              flexGrow: 1,
              textTransform: 'none',
              fontWeight: 600,
              fontSize: { xs: '14px', sm: '16px' },
              color: 'rgba(255, 255, 255, 0.6)',
              border: 'none',
              borderRadius: '12px',
              py: { xs: 1.2, sm: 1.5 },
              px: { xs: 1.5, sm: 3 },
              position: 'relative',
              zIndex: 1,
              transition: 'color 0.3s cubic-bezier(0.4, 0, 0.2, 1), transform 0.2s ease',
              // Hover state - only for non-selected tabs
              '&:not(.Mui-selected):hover': {
                color: 'rgba(255, 255, 255, 0.85)',
                bgcolor: 'rgba(255, 255, 255, 0.08)',
                transform: 'scale(1.02)',
              },
              // Selected state - distinct and bold
              '&.Mui-selected': {
                color: '#ffffff !important',
                fontWeight: 700,
                bgcolor: 'transparent',
                zIndex: 2,
                '&::before': {
                  content: '""',
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  background: 'linear-gradient(135deg, #f2674a 0%, #ff8a65 100%)',
                  borderRadius: '12px',
                  zIndex: -1,
                  boxShadow: '0 4px 20px rgba(242, 103, 74, 0.5), 0 2px 8px rgba(242, 103, 74, 0.3)',
                  animation: `${slideIn} 0.4s cubic-bezier(0.4, 0, 0.2, 1)`,
                },
                // Hover on selected tab - slightly brighter
                '&:hover': {
                  bgcolor: 'transparent',
                  color: '#ffffff !important',
                  // transform: 'scale(1.01)',
                  '&::before': {
                    boxShadow: '0 6px 25px rgba(242, 103, 74, 0.6), 0 2px 10px rgba(242, 103, 74, 0.4)',
                    background: 'linear-gradient(135deg, #f2674a 0%, #ff9a75 100%)',
                  }
                }
              },
            },
          }}
          aria-label="Loan Categories"
        >
          <ToggleButton value="Repayments">
            Repayments
          </ToggleButton>
          <ToggleButton value="Activeloans">
            Active Loans
          </ToggleButton>
          <ToggleButton value="History">
            History
          </ToggleButton>
        </ToggleButtonGroup>
      </Box>

      <Box sx={{
        position: 'relative',
        minHeight: '200px',
        transition: 'opacity 0.3s ease-in-out'
      }}>
        {selectedCategory === 'History' ? (
          <HistoryTable
            boosterLoanHistoryData={boosterLoanHistoryData}
          />
        ) : selectedCategory === 'Activeloans' ? (
          <ActiveLoans
            boosterLoanActiveData={boosterLoanActiveData}
            setIsUpdatePaymentMethod={setIsUpdatePaymentMethod}
          />
        ) : (
          <Repayment
            boosterLoanRepaymentData={boosterLoanRepaymentData}
            isrepayment={selectedCategory}
            setIsUpdatePaymentMethod={setIsUpdatePaymentMethod}
          />
        )}
      </Box>
    </Container>
  </>;
}

export default BoosterLoan;